<template>
  <el-row>
    <el-col>
      <el-breadcrumb separator="/" class="admincrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>文章</el-breadcrumb-item>
        <el-breadcrumb-item>分类管理</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <el-col class="'toolbar" style="text-align: right;">
      <el-form :inline="true" size="small" :model="sData" :rules="addrules" ref="ruleForm"  class="form-inline">
        <el-form-item label="分类名称">
          <el-input v-model="sData.title_icontains" placeholder="请输入分类名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button-group>
            <el-button type="primary" @click="sSubmit"><i class="el-icon-search" style="font-weight: bolder; margin-right: 6px;"></i>分类搜索</el-button>
            <el-button type="primary" @click="addShow = true"><i class="el-icon-" style="font-weight: bolder; margin-right: 6px;"></i>新增分类</el-button>
          </el-button-group>
        </el-form-item>
      </el-form>
    </el-col>
    <el-col>
      <el-table :data="currPg" stripe style="width: 100%">
        <el-table-column prop="ID" label="分类ID" width="100"></el-table-column>
        <el-table-column prop="title" label="分类名称" width="300"></el-table-column>
        <el-table-column prop="keywords" label="分类关键词" width="300"></el-table-column>
        <el-table-column prop="description" label="分类描述" width="300"></el-table-column>
        <el-table-column prop="description" label="单页分类" :formatter="pagecat" width="300"></el-table-column>
        <el-table-column prop="status" :formatter="catStatus" label="状态" width="100"></el-table-column>
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button-group>
              <el-button type="text" size="small" @click="catEdit(scope.row)">编辑</el-button>
              <el-button @click="catExStatus(scope.row)" type="text" size="small">状态</el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog :visible.sync="editShow" :before-close="handleClose" width="30%">
        <span>
            <el-form name="editForm" :model = "currEditCat" ref= "editCL" :rules="addrules" label-width="100px" class="gpform">
              <el-form-item label="分类名称" prop="title">
                <el-input v-model="currEditCat.title" placeholder="请输入分类标签" required></el-input>
              </el-form-item>
               <el-form-item label="单页分类">
                  <el-switch v-model="currEditCat.isPage"></el-switch>
                </el-form-item>
               <el-form-item label="分类关键词" prop="keywords" require>
                <el-input v-model="currEditCat.keywords" placeholder="请输入分类关键词" required></el-input>
              </el-form-item>
               <el-form-item label="分类描述" prop="description" require>
                <el-input v-model="currEditCat.description" placeholder="请用250内个字符介绍您的分类" required></el-input>
              </el-form-item>
              <el-form-item>
                <el-button-group>
                  <el-button @click="editShow = false">取 消</el-button>
                  <el-button type="primary" @click="updateClassify('editCL')">确 定</el-button>
                </el-button-group>
              </el-form-item>
            </el-form>
          </span>
      </el-dialog>
    </el-col>
    <el-col :span="24" class="pagenav" style="margin-top: 42px;">
        <el-pagination
        @current-change="handleCurrentChange"
        :current-page="pagenav.page"
        :page-sizes="[12]"
        :page-size="12"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagenav.total">
      </el-pagination>
    </el-col>
    <el-dialog :visible.sync="addShow" :before-close="handleClose" width="30%">
      <span>
          <el-form name="addForm" :model = "newClassify" ref= "newcategory" :rules="addrules" label-width="100px" class="gpform">
            <el-form-item label="分类名称" prop="title">
              <el-input v-model="newClassify.title" placeholder="请输入分类标签" required></el-input>
            </el-form-item>
             <el-form-item label="单页分类">
                <el-switch v-model="newClassify.isPage"></el-switch>
              </el-form-item>
             <el-form-item label="分类关键词" prop="keywords" require>
              <el-input v-model="newClassify.keywords" placeholder="请输入分类关键词" required></el-input>
            </el-form-item>
             <el-form-item label="分类描述" prop="description" require>
              <el-input type="textarea" :row="7" v-model="newClassify.description" placeholder="请用250内个字符介绍您的分类" required></el-input>
            </el-form-item>
            <el-form-item style="text-align: right">
              <el-button-group>
                <el-button @click="addShow = false">取 消</el-button>
                <el-button type="primary" @click="addClassify('newcategory')">确 定</el-button></el-button-group>
            </el-form-item>
          </el-form>
        </span>
    </el-dialog>
  </el-row>
</template>
<script>
export default{
  name: 'Classify',
  data () {
    return {
      sData: {},
      addShow: false,
      editShow: false,
      newClassify: {isPage: false},
      addrules: {
        title: [{ required: true, message: '分类标题不能为空', trigger: 'blur' }],
        keywords: [{ required: true, message: '分类关键词不能为空', trigger: 'blur' }],
        description: [{ required: true, message: '分类介绍不能为空', trigger: 'blur' }]
      },
      pagenav: {page: 1, total: 0},
      currPg: [],
      currEditCat: {}
    }
  },
  mounted: function () {
    this.loadPage(1)
  },
  methods: {
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    addClassify: function (fn) {
      var that = this
      this.$refs[fn].validate(valid => {
        if (valid) {
          var data = that.newClassify
          data['method'] = 'article.addClassify'
          that.$http.post(that.$apiurl, data).then(function (ret) {
            if (ret.body.code === 200) {
              that.$message.success('新增文章分类成功')
              that.addShow = false
            } else {
              that.$alert('文章分类新增失败，请稍后重试!')
            }
          })
        }
      })
    },
    handleCurrentChange: function (page) {
      this.loadPage(page)
    },
    pagecat: function (data) {
      if (data.isPage) {
        return ('单页分类')
      } else {
        return ('文章分类')
      }
    },
    catStatus: function (data) {
      if (data.status) {
        return ('启用')
      } else {
        return ('禁用')
      }
    },
    loadPage: function (page) {
      var data = this.sData
      data.page = page
      data.num = 12
      data.method = 'article.clpage'
      var that = this
      this.$http.post(that.$apiurl, data).then(function (ret) {
        that.pagenav.page = ret.body.data.page
        that.pagenav.total = ret.body.data.total
        that.currPg = ret.body.data.data
      })
    },
    catExStatus: function (row) {
      var that = this
      var currpage = that.pagenav.page
      var data = {CID: row.ID, method: 'article.clstate'}
      this.$http.post(that.$apiurl, data).then(function (ret) {
        if (ret.body.code === 200) {
          that.$message.success('分类状态修改成功')
          that.loadPage(currpage)
        } else {
          that.$alert('分类状态修改失败，请稍后重试!')
        }
      })
    },
    catEdit: function (row) {
      this.currEditCat = row
      this.editShow = true
    },
    updateClassify: function (fn) {
      var that = this
      var currpage = that.pagenav.page
      this.$refs[fn].validate(valid => {
        if (valid) {
          var data = that.currEditCat
          data.method = 'article.updateclassify'
          this.$http.post(that.$apiurl, data).then(function (ret) {
            if (ret.body.code === 200) {
              that.$message.success('分类修改成功')
              that.loadPage(currpage)
              that.editShow = false
            } else {
              that.$alert('分类修改失败，请稍后重试!')
            }
          })
        }
      })
    },
    sSubmit: function () {
      this.loadPage(1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shop/classify.vue